const {
  getLocation,
  getHistory,
  parseQueryString,
  createNewQueryString,
  clearFromQueryString
} = require("../../../../utils/location");


const isQueryStringEmpty = str => {
  const _str = (str || '').trim();
  const emptyValues = ['', '?', '?='];
  return emptyValues.some(v => v === _str);
}

// LADR - LINES AGGS DATE RANGE
const DEFAULT_PROPS = {};
const CACHE = {
  PROPS: {},
  isLoaded: false,
  URL_ROOT_KEY: 'LADR',
};

const _setLocal = (props = {}) => {
  const { type, from, to, enabled } = props;
  CACHE.PROPS = { type, from, to, enabled };
};

const _clearLocal = () => { 
  CACHE.PROPS = {...DEFAULT_PROPS};
}

const loadCacheFromUrl = () => {
  const location = getLocation();
  const urlparams = parseQueryString(location?.search) || {};
  CACHE.PROPS = JSON.parse(urlparams[CACHE.URL_ROOT_KEY] || JSON.stringify(DEFAULT_PROPS));
  CACHE.isLoaded = true;
  return CACHE.PROPS;
}

const _writeToUrl = () => { 
  const location = getLocation();
  const history = getHistory();
  let queryString = clearFromQueryString(CACHE.URL_ROOT_KEY, location.search);
  if (CACHE.PROPS?.enabled) {
    queryString = createNewQueryString([CACHE.URL_ROOT_KEY, JSON.stringify(CACHE.PROPS)], queryString);
  }

  if (history?.pushState) {
    let newUrl = location.href.split('?')[0];
    if (!isQueryStringEmpty(queryString)) {
      newUrl += queryString;
    }
    if (newUrl !== location.href) {
      history.pushState({}, '', newUrl);
    }
  } else { 
    // fallback
    location.search = !isQueryStringEmpty(queryString) ? queryString : '';
  }

}

const setValueInUrl = (type, from, to, enabled) => { 
  _setLocal({ type, from, to, enabled });
  _writeToUrl();
}

const clearUrl = () => { 
  _clearLocal();
  _writeToUrl();
}

const LADR_UTIL = {
  loadCacheFromUrl,
  setValueInUrl,
  clearUrl,
  CACHE
}

export default LADR_UTIL;





